import { z } from 'zod';
import { ADMISSION_DECISIONS, ADMISSION_STATUSES, JOIN_POLICIES } from '../registries/admission.ts';
import { GuestPublic } from './identity.ts';
import { Id, IsoDateTime, PageQuery } from './primitives.ts';

export const JoinPolicySchema = z.enum(JOIN_POLICIES);
export const AdmissionStatusSchema = z.enum(ADMISSION_STATUSES);
export const AdmissionDecisionSchema = z.enum(ADMISSION_DECISIONS);

/** A guest's request to enter a screening and where it stands. */
export const Admission = z.object({
  id: Id,
  screeningId: Id,
  guest: GuestPublic,
  /** LiveKit identity the guest will have in the room. */
  identity: z.string(),
  status: AdmissionStatusSchema,
  requestedAt: IsoDateTime,
  decidedAt: IsoDateTime.nullable(),
  decidedBy: z.object({ displayName: z.string() }).nullable(),
});
export type Admission = z.infer<typeof Admission>;

/** Oldest request first, so hosts answer in arrival order. Without `status`, every admission is listed. */
export const AdmissionListQuery = PageQuery.extend({ status: AdmissionStatusSchema.optional() });

export const DecideAdmissionBody = z.object({ decision: AdmissionDecisionSchema });
